import { openDB } from 'idb';

const DB_NAME = 'philcrm';
const STORE = 'offline_queue';

async function getDB() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { autoIncrement: true });
    },
  });
}

export async function addToOfflineQueue(config) {
  const db = await getDB();
  await db.add(STORE, { url: config.url, method: config.method, data: config.data, headers: config.headers, _offlineWorkspacePinned: true });
}

export async function getOfflineQueue() {
  const db = await getDB();
  return db.getAll(STORE);
}

export async function clearOfflineQueue() {
  const db = await getDB();
  await db.clear(STORE);
}
